<section class="menu-section">
  <!-- Video fondo -->
  <video class="background-video" autoplay muted loop playsinline>
    <source src="assets/images/fondoHumo2.mp4" type="video/mp4" />
  </video>

  <!-- Contenido -->
  <div class="menu-container">
    <h2 class="menu-title">Nuestro Menú</h2>

    <mat-tab-group
      *ngIf="!loadingCategorias; else loadingTpl"
      (selectedIndexChange)="onTabChange($event)"
      animationDuration="400ms"
      class="menu-tabs"
    >
      <mat-tab
        *ngFor="let categoria of categorias; trackBy: trackByCategoria"
        [label]="categoria.name"
      >
        <div
          class="menu-list"
          *ngIf="!loadingProductos; else loadingProductosTpl"
        >
          <article
            class="menu-item"
            *ngFor="
              let producto of productos$ | async;
              trackBy: trackByProducto
            "
          >
            <div class="menu-item-img">
              <img
                [src]="producto.imageUrl || 'assets/images/no-image.png'"
                [alt]="producto.name"
              />
            </div>

            <div class="menu-item-info">
              <p class="menu-price">${{ producto.price }}</p>
              <h4 class="menu-item-title">{{ producto.name }}</h4>
              <p class="menu-item-desc">{{ producto.description }}</p>

              <button
                class="add-to-cart"
                [disabled]="!producto.isAvailable"
                (click)="agregarAlCarrito(producto)"
              >
                {{
                  producto.agregadoTemporal
                    ? "✔ Agregado con éxito"
                    : "+ Agregar al carrito"
                }}
              </button>
            </div>
          </article>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <!-- loaders -->
  <ng-template #loadingTpl>
    <div class="center">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  </ng-template>

  <ng-template #loadingProductosTpl>
    <div class="center">
      <mat-spinner diameter="30"></mat-spinner>
    </div>
  </ng-template>
</section>

<!-- BOTÓN FLOTANTE CARRITO -->
<button
  class="floating-cart-btn"
  (click)="cartOpen = true"
  *ngIf="!cartOpen"
  [class.burst]="cartAnimation"
>
  <mat-icon>shopping_cart</mat-icon>
  <span class="badge" *ngIf="cantidadCarrito > 0">
    {{ cantidadCarrito }}
  </span>
  <span class="cart-pulse" *ngIf="cartAnimation"></span>
</button>

<!-- DRAWER CARRITO -->
<aside class="cart-drawer" [class.open]="cartOpen">
  <header class="drawer-header">
    <h3>Tu Pedido</h3>
    <button class="close-btn" (click)="cartOpen = false">✕</button>
  </header>

  <div class="cart-items">
    <article
      class="cart-item"
      *ngFor="let item of carrito; let i = index"
      (click)="editarItem(i)"
    >
      <button
        class="remove-btn"
        (click)="eliminarItem(i); $event.stopPropagation()"
        aria-label="Eliminar producto"
      >
        ✕
      </button>

      <img
        class="cart-item-img"
        [src]="item.imageUrl || 'assets/images/no-image.png'"
        [alt]="item.nombre"
      />

      <div class="cart-item-info">
        <p class="cart-item-title">{{ item.nombre }}</p>
        <p class="cart-item-extras" *ngIf="item.extras?.length">
          {{ item.extras.length }}
          extra{{ item.extras.length > 1 ? "s" : "" }}
        </p>
      </div>

      <p>Cantidad: {{ item.cantidad }}</p>
      <span class="cart-item-price">${{ item.total }}</span>
    </article>

    <p *ngIf="carrito.length === 0" class="empty">Carrito vacío</p>
  </div>

  <div class="container-total">
    <p class="cart-total" *ngIf="carrito.length !== 0">
      Total del pedido:
      <strong>${{ totalPedido }}</strong>
    </p>
  </div>

  <form
    *ngIf="carrito.length > 0"
    class="checkout-form"
    [formGroup]="checkoutForm"
  >
    <div class="checkout-header" (click)="toggleForm()">
      <h4>Datos del pedido</h4>

      <span
        class="chevron"
        [class.open]="formAbierto"
        aria-label="Expandir formulario"
      >
        ▾
      </span>
    </div>

    <div class="checkout-content" [class.open]="!formAbierto">
      <div class="form-group">
        <label>Nombre</label>
        <input type="text" formControlName="nombre" placeholder="Tu nombre" />
      </div>

      <div class="form-group">
        <label>Teléfono</label>
        <input
          type="tel"
          formControlName="telefono"
          placeholder="Ej: 3412345678"
        />
      </div>

      <div class="form-group">
        <label>Tipo de pedido</label>
        <div class="radio-group">
          <label>
            <input type="radio" value="local" formControlName="tipoEntrega" />
            Retiro en local
          </label>

          <label *ngIf="tieneDelivery">
            <input
              type="radio"
              value="delivery"
              formControlName="tipoEntrega"
            />
            Delivery
          </label>
        </div>
      </div>

      <div
        class="form-group"
        *ngIf="checkoutForm.value.tipoEntrega === 'delivery'"
      >
        <label>Dirección</label>
        <input
          type="text"
          formControlName="direccion"
          placeholder="Dirección completa"
        />
      </div>

      <div class="form-group">
        <label>Método de pago</label>

        <div class="radio-group">
          <label>
            <input type="radio" value="efectivo" formControlName="metodoPago" />
            Efectivo
          </label>

          <label>
            <input type="radio" value="tarjeta" formControlName="metodoPago" />
            Tarjeta
          </label>
        </div>

        <div class="radio-group" style="margin-top: 8px">
          <label>
            <input type="radio" value="qr" formControlName="metodoPago" />
            QR
          </label>

          <label>
            <input
              type="radio"
              value="transferencia"
              formControlName="metodoPago"
            />
            Transferencia
          </label>
        </div>
      </div>

      <div class="form-group">
        <label>Notas del pedido</label>
        <textarea
          rows="3"
          formControlName="notas"
          placeholder="Ej: sin cebolla, llamar al llegar, pago con cambio..."
        ></textarea>
      </div>

      <button
        class="submit-btn"
        [disabled]="checkoutForm.invalid"
        (click)="confirmarPedido()"
        type="button"
      >
        Enviar pedido
      </button>
    </div>
  </form>
</aside>

<!-- BACKDROP -->
<div class="cart-backdrop" *ngIf="cartOpen" (click)="cartOpen = false"></div>
